import beckettLogo from '@/assets/beckett.png';
import cgcLogo from '@/assets/cgc.png';
import psaLogo from '@/assets/psa.png';
import sgcLogo from '@/assets/sgc.png';

export const GRADER_LOGOS = {
  psa: psaLogo,
  cgc: cgcLogo,
  sgc: sgcLogo,
  beckett: beckettLogo,
};

export function graderLogoSrc(grader) {
  if (!grader) return null;
  return GRADER_LOGOS[grader] || null;
}
